import { render, staticRenderFns } from "./BaseTextInfo.vue?vue&type=template&id=2b4fb87a&scoped=true"
import script from "./BaseTextInfo.vue?vue&type=script&lang=js"
export * from "./BaseTextInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseTextInfo.vue?vue&type=style&index=0&id=2b4fb87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fb87a",
  null
  
)

export default component.exports